export interface OnboardingLearnMoreInterestsData {
  knowledge?: boolean;
  websiteSmartAssistant?: boolean;
  phoneSmartAssistant?: boolean;
  whatsAppSmartAssistant?: boolean;
  facebookSmartAssistant?: boolean;
  instagramSmartAssistant?: boolean;
  discordSmartAssistant?: boolean;
  shopifySmartAssistant?: boolean;
}

export interface OnboardingData {
  learnMoreInterests?: OnboardingLearnMoreInterestsData;
  industry?: OnboardingIndustry | string;
  primaryInterests?: OnboardingPrimaryInterest[];
  discoverySource?: string;
}

export enum OnboardingPrimaryInterest {
  PHONE = 'phone',
  WHATSAPP = 'messaging_whatsapp',
  FACEBOOK = 'messaging_facebook',
  INSTAGRAM = 'messaging_instagram',
  DISCORD = 'messaging_discord',
  WEBSITE = 'website',
  SHOPIFY = 'shopify'
}

export enum OnboardingIndustry {
  HOME_SERVICES = 'home services',
  ECOMMERCE = 'ecommerce',
  HOSPITALITY = 'hospitality',
  REAL_ESTATE = 'real estate',
  HEALTHCARE = 'healthcare',
  AUTOMOTIVE = 'automotive',
  LEGAL = 'legal',
  AGENCY = 'agency'
}
